<template>
    <div :style="isMobile?'margin:20px':'margin:40px'">
        <div :style="isMobile?'margin:0px 15px 0px 15px':''">
            <p :class="isMobile?'section-content-mobile text-xs-left':'section-content text-xs-left'" v-html="data.title" style="font-family:Roboto;"></p>
            <p :class="isMobile?'section-content-description-mobile text-xs-left':'section-content-description text-xs-left'" v-html="data.description" style="font-family:Roboto;"></p>
        </div>
        <v-list v-if="!isMobile" three-line class="transparent">
            <template v-for="(item) in data.details">
                <v-list-tile>
                    <v-list-tile-avatar>
                        <v-icon size="30" style="margin-top:10px;">{{item.icon}}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <div v-html="item.title" class="font-weight-bold"></div>
                        <div v-html="item.description" class="section-item-description"></div>
                    </v-list-tile-content>
                </v-list-tile>
            </template>
            <v-card-actions style="margin-top:30px">
                <v-spacer></v-spacer>
                <v-btn flat small @click="readMore(data.nextId)" v-if="data.nextId">Learn more</v-btn>
            </v-card-actions>
        </v-list>
        <div v-if="isMobile" class="transparent">
            <div class="transparent">
                <div v-for="(item) in data.details" class="container-mobile transparent">
                    <div class="icon-column-mobile">
                        <v-icon size="30" style="margin-top:10px;">{{item.icon}}</v-icon>
                    </div>
                    <div class="description-column-mobile">
                        <div v-html="item.title" class="font-weight-bold"></div>
                        <div v-html="item.description" class="section-item-description"></div>
                    </div>
                </div>
            </div>
        </div>
        <v-dialog v-model="dialogPicViewer" fullscreen hide-overlay transition="dialog-bottom-transition">
            <image-viewer ref="picViewerRef" :dialogPicViewer.sync="dialogPicViewer"></image-viewer>
        </v-dialog>
    </div>
</template>
<script>
import * as easings from 'vuetify/es5/util/easing-patterns'
export default {
    data() {
        return {
            duration: 750,
            offset: 70,
            easing: 'easeInOutCubic',
            dialogPicViewer: false,
        }
    },
    components: {
        'image-viewer': () => import('@/components/ImageViewer'),
    },
    props: ['data'],
    methods: {
        readMore(nextId) {
            if (nextId) this.$vuetify.goTo(`#${nextId}`, this.options)
        },
        viewSample(image) {
            this.$refs.picViewerRef.viewPic(image)
            this.dialogPicViewer = true
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
        options () {
            return {
                duration: this.duration,
                offset: this.offset,
                easing: this.easing
            }
        }
    },
    created() {}
}
</script>